"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PocketSettlementType = exports.PocketSettlementValueType = exports.PocketEntryIncludeFilter = void 0;
var PocketEntryIncludeFilter;
(function (PocketEntryIncludeFilter) {
    PocketEntryIncludeFilter["EXPENSE"] = "expense";
    PocketEntryIncludeFilter["POCKET_TRANSFER"] = "transferExpense";
})(PocketEntryIncludeFilter = exports.PocketEntryIncludeFilter || (exports.PocketEntryIncludeFilter = {}));
var PocketSettlementValueType;
(function (PocketSettlementValueType) {
    PocketSettlementValueType["HAS_ZERO_VALUE"] = "HAS_ZERO_VALUE";
    PocketSettlementValueType["HAS_DIFF_VALUE"] = "HAS_DIFF_VALUE";
    PocketSettlementValueType["HAS_ACCURATE_VALUE"] = "HAS_ACCURATE_VALUE";
})(PocketSettlementValueType = exports.PocketSettlementValueType || (exports.PocketSettlementValueType = {}));
var PocketSettlementType;
(function (PocketSettlementType) {
    PocketSettlementType["PERSONAL_TRANSFER"] = "PERSONAL_TRANSFER";
    PocketSettlementType["MANUAL_TRANSFER"] = "MANUAL_TRANSFER";
    PocketSettlementType["EMPLOYEE_BANK_TRANSFER"] = "EMPLOYEE_BANK_TRANSFER";
})(PocketSettlementType = exports.PocketSettlementType || (exports.PocketSettlementType = {}));
//# sourceMappingURL=pocket.js.map